import { useProductLayout } from '@monofront/business/hooks';
import { IProduct } from '@monofront/types';
import {
  SlicesContainer,
  SlicesContainerLayoutType,
} from '@screens/SlicesContainer';

interface IProductFooterProps {
  product: IProduct;
}

const ProductFooter: React.FC<IProductFooterProps> = () => {
  const { productLayout } = useProductLayout();
  const slices = productLayout.slices.length
    ? productLayout.slices.slice(productLayout.slices_before_desc || 0)
    : [];

  return (
    <section className={`tw-mb-12 tw-mt-16`}>
      {slices.length > 0 ? (
        <SlicesContainer
          pageContents={slices}
          layout={SlicesContainerLayoutType.INSIDE}
        />
      ) : null}
    </section>
  );
};

export default ProductFooter;
